
const readcsv = ({ file }) => {
    var teleportation_distance_sheet = file;
    teleportation_distance_sheet.pop();
    return { csvarray: teleportation_distance_sheet };



}

export default readcsv